import React, { useContext, useState } from "react";

import {
  Card,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";

import { makeStyles } from "@mui/styles";

import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

import { LISTA_MENU, LISTA_OPCIONES } from "../constants/constants";
import TransaccionalContext from "../context/TransaccionalContext";

const useStylesMenu = makeStyles((theme) => ({
  itemNormal: {
    justifyContent: "center",
    borderRadius: "20px !important",
  },

  itemSelected: {
    justifyContent: "center",
    backgroundColor: "#fbdfdd !important",
    borderRadius: "25px !important",
    /* padding: "0 1.5px", */
  },
}));

const useStylesButtonColapse = makeStyles((theme) => ({
  buttonColapse: {
    position: "absolute",
    top: "-22px",
    left: "50%",
    transform: "translateX(-50%)",
    background: "white",
    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.2)",
    "&:hover": {
      background: "white",
    },
  },
}));

const DetalleOptionsMenu = ({ isColapse, handleColapse, alturaResolucion }) => {
  const { informacionTransaccional, setInformacionTransaccional } =
    useContext(TransaccionalContext);

  const [menuOptions, setMenuOptions] = useState(LISTA_MENU);
  const styleMenu = useStylesMenu();
  const styleButtonColapse = useStylesButtonColapse();

  const handleListaAutorizaciones = (id) => {
    setInformacionTransaccional((args) => ({
      ...args,
      opcionMenu: id,
    }));

    setMenuOptions((args) =>
      args?.map((item) => {
        if (item.id === id) {
          return { ...item, isSelected: true };
        }
        return { ...item, isSelected: false };
      })
    );
  };

  return (
    <main className="movimientoCliente-menu">
      {/* Menu de opciones de mov. */}
      <section className="movimientoCliente-menu-container">
        {isColapse ? (
          <IconButton
            className={styleButtonColapse.buttonColapse}
            aria-label="calapse-right"
            size="large"
            onClick={handleColapse}
          >
            <ArrowForwardIosIcon />
          </IconButton>
        ) : (
          <IconButton
            className={styleButtonColapse.buttonColapse}
            aria-label="calapse-right"
            size="large"
            onClick={handleColapse}
          >
            <ArrowBackIosNewIcon />
          </IconButton>
        )}
        <Card
          sx={{
            minHeight: `${alturaResolucion}px`,
            maxHeight: `${alturaResolucion}px`,
            borderRadius: "25px",
          }}
        >
          <List
            sx={{
              padding: "0 1.5rem",
              marginTop: "1.5rem",
              overflow: "auto",
              maxHeight: `${alturaResolucion}px`,
              paddingBottom: "2.5rem",

              "@media (max-width: 1360px)": {
                padding: "0 0.5rem",
                marginTop: "1.5rem",
                overflow: "auto",
                maxHeight: `${alturaResolucion}px`,
                paddingBottom: "2.5rem",
              },
            }}
            className="movimientoCliente-menu-items"
          >
            {menuOptions.map((opcion, index) => (
              <>
                <ListItem
                  key={opcion.id}
                  disablePadding={false}
                  sx={{
                    "@media (max-width: 1360px)": {
                      padding: "0.3rem 0.3rem",
                    },
                  }}
                >
                  <ListItemButton
                    onClick={() => handleListaAutorizaciones(opcion.id)}
                    className={
                      opcion?.isSelected
                        ? styleMenu.itemSelected
                        : styleMenu.itemNormal
                    }
                    selected={opcion?.isSelected}
                  >
                    <ListItemIcon
                      sx={
                        isColapse && {
                          minWidth: 0,
                          paddingLeft: 0,
                          paddingRight: 0,
                        }
                      }
                    >
                      {opcion.iconMenu}
                    </ListItemIcon>

                    {!isColapse && (
                      <ListItemText
                        sx={{
                          "& .css-13msg1i-MuiTypography-root": {
                            "@media (max-width: 1360px)": {
                              fontSize: "12.6px",
                            },
                          },
                        }}
                        primary={opcion.name}
                      />
                    )}
                  </ListItemButton>
                </ListItem>
                <Divider />
              </>
            ))}
          </List>
        </Card>
      </section>
    </main>
  );
};

export default DetalleOptionsMenu;
